import { ProgrammeReference } from '@types';

export const PRIMARY_YEAR_GROUPS = [1, 2, 3, 4, 5, 6];
export const SECONDARY_YEAR_GROUPS = [7, 8, 9, 10, 11];

export const SECONDARY_PROGRAMMES = [ProgrammeReference.GCSE];
